export default class {
  constructor() {
      this.hoverNav = '.js-hoverNav';
      this.trigger = '.js-hoverNav__trigger';
      this.img = '.js-hoverNav__img';
      this.init();
  }

  init() {
    const trigger = document.addEventListener("mouseover" , (event) => {
      const trigger = document.getElementById('nav-career');
      trigger.dataset.nav
    })
  }
}